import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-warning-notice',
  templateUrl: './warning-notice.component.html',
  styleUrls: ['./warning-notice.component.scss'],
})
export class WarningNoticeComponent {
  @Input() header: string = '';
  @Input() text: string = '';
}
